import { Grid, Slider } from "@mui/material";
import React, { useMemo } from "react";

import { FixedMidpointRoundingToDown } from "utils/helpers/numbers";
import { TRADE_AMOUNT_TYPE } from "../constants";
import { calculateMaximumTradeAmount } from "utils/helpers/trade";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

const marks = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 25,
    label: "25%",
  },
  {
    value: 50,
    label: "50%",
  },
  {
    value: 75,
    label: "75%",
  },
  {
    value: 100,
    label: "100%",
  },
];

function TradeRange({ srcDecimalCount, destDecimalCount }) {
  const { watch, setValue } = useFormContext();
  const amountTypeId = watch("amountTypeId");
  const sideId = watch("sideId");
  const price = watch("price") || 0;
  const tradeTypeId = watch("tradeTypeId");
  const amount = watch("amount");

  const tradeAmountMax = useSelector(
    (state) => state.trade?.tradeAmountMax?.data
  );

  const maximumTradeAmount = useMemo(
    () =>
      calculateMaximumTradeAmount({
        sideId,
        amountTypeId,
        tradeTypeId,
        tradeAmountMax,
        srcDecimalCount,
        destDecimalCount,
        price,
      }),
    [
      amountTypeId,
      destDecimalCount,
      srcDecimalCount,
      tradeAmountMax,
      price,
      sideId,
      tradeTypeId,
    ]
  );

  const handleChangeRange = (_, newValue) => {
    const calculatedAmount = (+newValue * +maximumTradeAmount) / 100;

    const decimalCount =
      amountTypeId === TRADE_AMOUNT_TYPE.amount.id
        ? srcDecimalCount
        : destDecimalCount;

    const roundedAmount = FixedMidpointRoundingToDown(
      +calculatedAmount,
      decimalCount
    );

    setValue("amount", roundedAmount);
  };

  const value = useMemo(() => {
    if (maximumTradeAmount) {
      return FixedMidpointRoundingToDown(
        (+amount * 100) / +maximumTradeAmount,
        0
      );
    } else {
      return 0;
    }
  }, [amount, maximumTradeAmount]);

  return (
    <Grid container>
      <Grid item xs={12} px={2}>
        <Slider
          color="success"
          defaultValue={50}
          value={value}
          step={1}
          valueLabelDisplay="auto"
          onChange={handleChangeRange}
          marks={marks}
        />
      </Grid>
    </Grid>
  );
}

export default TradeRange;
